import { MatchInterviewType } from '@pflegia/types/common/enums';

export const InterviewConfirmationChatTemplate = `Hallo {{{candidateName}}}!

Folgender Termin wurde bestätigt:

{{{dates}}}

Alle weiteren Informationen zu dem Termin erhalten Sie per E-Mail.

Das gesamte Team von Pflegia wünscht Ihnen viel Erfolg!`;

export interface InterviewReminderChatMessageTemplate {
  formal: string;
  informal: string;
}

type TemplateByMatchInterviewType = {
  [key in
    | MatchInterviewType.Interview
    | MatchInterviewType.TrialDay
    | MatchInterviewType.Telephonic
    | MatchInterviewType.Digital]: readonly InterviewReminderChatMessageTemplate[];
};

const interviewTypeTemplates: readonly InterviewReminderChatMessageTemplate[] = [
  {
    informal: `Hallo {{{candidateFirstName}}}, wir freuen uns schon auf das Vorstellungsgespräch mit dir am {{{interviewWeekDay}}}, den {{{interviewDate}}} um {{{interviewTime}}} Uhr.
Dieses findet wie vereinbart{{{location}}} statt.
Bitte bring deine Bewerbungsunterlagen persönlich mit.`,
    formal: `Guten Tag {{{candidateLastNameWithSalutation}}},
wir freuen uns auf Ihr Vorstellungsgespräch morgen, {{{interviewDate}}} um {{{interviewTime}}}{{{location}}}.
Der Termin ist bereits fest eingeplant, und wir sind gespannt, Sie persönlich kennenzulernen.
Bringen Sie bitte, wenn möglich, Ihren Lebenslauf und – sofern vorhanden – Ihre Urkunde mit.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}}, hiermit möchte ich dich an deinen Termin am {{{interviewDate}}} erinnern. Dein Vorstellungsgespräch findet um {{{interviewTime}}}{{{location}}} statt.
Wir freuen uns darauf, dich persönlich kennenzulernen.
Bitte bring deinen Lebenslauf und, sofern vorhanden, deine Urkunde mit.`,
    formal: `Guten Tag {{{candidateLastNameWithSalutation}}},
eine kleine Erinnerung an Ihr morgiges Vorstellungsgespräch um {{{interviewTime}}}{{{location}}}.
Wir freuen uns sehr auf das persönliche Kennenlernen.
Wenn Sie Ihren Lebenslauf und Ihre Urkunde dabei haben, ist das ideal – ansonsten ist das selbstverständlich kein Problem.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}}, schön, dass wir morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}} für dein Vorstellungsgespräch fest eingeplant sind.
Wenn möglich, bring bitte deinen Lebenslauf und deine Urkunde (wenn vorhanden) mit in die Einrichtung.
Wir freuen uns auf das Kennenlernen!`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
Ihr Vorstellungsgespräch morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}} ist fest eingeplant, und wir freuen uns auf das Gespräch mit Ihnen.
Falls möglich, bringen Sie bitte Ihren Lebenslauf und Ihre Urkunde mit.
Wir wünschen Ihnen einen angenehmen Termin und eine gute Anreise.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}}, dein Vorstellungsgespräch ist morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}}.
Wir freuen uns auf dich und haben uns den Termin schon vorgemerkt.
Bring bitte deinen Lebenslauf und deine Urkunde (wenn vorhanden) mit. Bis morgen!`,
    formal: `Guten Tag {{{candidateLastNameWithSalutation}}},
 hier eine kurze Erinnerung an Ihr Vorstellungsgespräch morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}}.
Wir freuen uns auf das Gespräch. Wenn vorhanden, bringen Sie gern Lebenslauf und Urkunde mit.
Falls der Termin für Sie doch nicht passt, geben Sie uns bitte kurz Bescheid und schlagen Sie gern ein alternatives Zeitfenster vor.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}}, wir freuen uns schon, dich morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}} beim Vorstellungsgespräch Gespräch kennenzulernen.
Es wäre ideal, wenn du an deinen Lebenslauf und ggf. deine Urkunde sowie Arbeitszeugnisse denkst.`,
    formal: `Hallo {{{candidateLastNameWithSalutation}}},
Ihr Termin für das Vorstellungsgespräch findet morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}} statt.
Wir freuen uns darauf, Sie kennenzulernen. Dokumente wie Lebenslauf oder Urkunde können Sie gern mitbringen.
Sollte es zeitlich nicht klappen, melden Sie sich bitte kurz – wir finden gemeinsam einen anderen Termin.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}}, nur kurz zur Erinnerung: Morgen, {{{interviewDate}}}, um {{{interviewTime}}} ist dein Vorstellungsgespräch{{{location}}}.
Wir freuen uns, dass du dir die Zeit nimmst.
Bring gern deinen Lebenslauf und deine Urkunde (wenn vorhanden) mit.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
wir möchten Sie an Ihr Vorstellungsgespräch morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}} erinnern.
Wir freuen uns auf das Kennenlernen. Falls möglich, bringen Sie bitte Ihren Lebenslauf und Ihre Urkunde mit.
Sollten Sie verhindert sein, bitten wir um eine kurze Rückmeldung sowie einen Terminvorschlag für eine Alternative.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}}, wir haben für morgen um {{{interviewTime}}}{{{location}}} alles für dein Vorstellungsgespräch vorbereitet.
Schön, dass du kommst.
Wenn du magst, bring bitte deinen Lebenslauf und deine Urkunde (falls vorhanden) mit.`,
    formal: `Guten Tag {{{candidateLastNameWithSalutation}}},
 Ihr Vorstellungsgespräch findet morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}} statt.
 Wir freuen uns auf Sie. Lebenslauf und Urkunde dürfen Sie gern mitbringen.
 Wenn der Termin doch nicht passt, sagen Sie bitte kurz ab und nennen Sie uns mögliche Alternativzeiten.`,
  },
  {
    informal: `Hi {{{candidateFirstName}}}, dein Vorstellungsgespräch ist morgen, {{{interviewDate}}}, um {{{interviewTime}}}{{{location}}}.
Wir freuen uns auf dich und sind schon vorbereitet.
Falls du sie hast, nimm bitte deinen Lebenslauf und deine Urkunde (wenn vorhanden) mit.`,
    formal: `Hallo {{{candidateLastNameWithSalutation}}},
morgen steht Ihr Vorstellungsgespräch um {{{interviewTime}}}{{{location}}} an.
Das Gespräch ist ganz entspannt – bringen Sie bei Bedarf einfach Ihren Lebenslauf und Ihre Urkunde mit. Wir freuen uns auf Sie.
Sollten Sie morgen keine Zeit haben, schreiben Sie uns bitte kurz und teilen Sie uns mögliche Ersatztermine mit.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}}, wir freuen uns schon auf das morgige Gespräch mit dir!
Wir werden dich um {{{interviewTime}}}{{{location}}} zu deinem Vorstellungsgespräch begrüßen!
Bring einfach deinen Lebenslauf und, wenn vorhanden, deine Urkunde mit.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
morgen, {{{interviewDate}}}, um {{{interviewTime}}} begrüßen wir Sie zu Ihrem Vorstellungsgespräch{{{location}}}.
Wir freuen uns auf ein angenehmes Gespräch. Bringen Sie gern Lebenslauf und Urkunde mit, falls vorhanden.
Falls Sie verhindert sind, bitten wir um eine kurze Absage sowie Ihren Vorschlag für einen alternativen Termin.`,
  },
  {
    informal: `Hey {{{candidateFirstName}}}, schön, dass du morgen Zeit hast für dein Vorstellungsgespräch um {{{interviewTime}}}{{{location}}}.
Wir freuen uns schon sehr auf dich.
Wenn du magst, bring deinen Lebenslauf und deine Urkunde (wenn vorhanden).`,
    formal: `Guten Tag {{{candidateLastNameWithSalutation}}},
schön, dass Sie morgen, am {{{interviewDate}}}, Zeit für Ihr Vorstellungsgespräch um {{{interviewTime}}}{{{location}}} haben.
Wir freuen uns wirklich, Sie kennenzulernen.
Bitte bringen Sie Ihren Lebenslauf und Ihre Urkunde mit – das erleichtert den Austausch.`,
  },
] as const;

const trialDayTypeTemplates: readonly InterviewReminderChatMessageTemplate[] = [
  {
    informal: `Hallo {{{candidateFirstName}}},
wir freuen uns sehr auf das Probearbeiten mit dir morgen um {{{interviewTime}}},{{{location}}}, sowie auf auf den gemeinsamen Tag.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
wir freuen uns sehr auf das Probearbeiten am {{{interviewDate}}} um {{{interviewTime}}},{{{location}}}, und blicken dem gemeinsamen Tag mit Ihnen voller Vorfreude entgegen.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}},
wir freuen uns, dich am {{{interviewDate}}} um {{{interviewTime}}}{{{location}}} zu lernen und gemeinsam einen produktiven Tag zu verbringen.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
wir freuen uns auf Ihr Probearbeiten am {{{interviewDate}}} um {{{interviewTime}}},{{{location}}}, und auf einen produktiven gemeinsamen Tag.`,
  },
  {
    informal: `Hi {{{candidateFirstName}}},
schön, dass du morgen bei uns bist. Wir freuen uns sehr auf das Probearbeiten um {{{interviewTime}}},{{{location}}} und auf die gemeinsame Zeit.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
herzlichen Dank für Ihre Zeit. Wir sehen dem Probearbeiten am {{{interviewDate}}} um {{{interviewTime}}} mit großer Vorfreude entgegen. Wir freuen uns auf die Zusammenarbeit. Die Hospitation findet{{{location}}} statt.`,
  },
] as const;

const telephonicTypeTemplates: readonly InterviewReminderChatMessageTemplate[] = [
  {
    informal: `Hallo {{{candidateFirstName}}},
wir freuen uns sehr darauf, morgen am {{{interviewDate}}} um {{{interviewTime}}} mit dir telefonisch zu sprechen. Besonders schön finden wir, mehr über deinen Weg in der Pflege zu erfahren.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
vielen Dank für Ihre Rückmeldung. Wir freuen uns auf das Telefonat am {{{interviewDate}}} um {{{interviewTime}}} und darauf, Ihren beruflichen Hintergrund in der Pflege näher kennenzulernen.`,
  },
  {
    informal: `Hi {{{candidateFirstName}}},
schön, dass wir morgen telefonisch miteinander sprechen! Am {{{interviewDate}}} um {{{interviewTime}}} möchten wir gerne mehr über deine Erfahrungen aus der Pflegepraxis hören.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
wir bestätigen Ihnen sehr gerne den telefonischen Termin am {{{interviewDate}}} um {{{interviewTime}}}. Wir freuen uns darauf, mit Ihnen über Ihre bisherigen Pflegeerfahrungen ins Gespräch zu kommen.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}},
wir freuen uns schon sehr auf unser Telefonat am {{{interviewDate}}} um {{{interviewTime}}}. Es ist uns wichtig, dich als Pflegekraft persönlich kennenzulernen und zu erfahren, was dich motiviert.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
herzlichen Dank für Ihre Terminbestätigung. Wir freuen uns darauf, Sie am {{{interviewDate}}} um {{{interviewTime}}} am Telefon zu begrüßen und mehr über Ihre Arbeit in der Pflege zu erfahren.`,
  },
  {
    informal: `Hi {{{candidateFirstName}}},
klasse, dass wir morgen telefonisch sprechen! Am {{{interviewDate}}} um {{{interviewTime}}} möchten wir dir gerne einen ersten Einblick in unsere Einrichtung geben und hören, welche Schwerpunkte du in der Pflege mitbringst.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
wir freuen uns auf unser telefonisches Gespräch am {{{interviewDate}}} um {{{interviewTime}}}. Besonders interessiert uns, wie Sie Ihre Stärken im Pflegealltag sehen und welche Arbeitsbedingungen Ihnen wichtig sind.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}},
wie schön, dass wir morgen ein Telefonat haben! Am {{{interviewDate}}} um {{{interviewTime}}} freuen wir uns darauf, mit dir über deine Erfahrungen im Pflegebereich und deine Wünsche für die Zukunft zu sprechen.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
wir sehen dem Telefonat am {{{interviewDate}}} um {{{interviewTime}}} mit Freude entgegen. Uns ist es ein Anliegen, in einem persönlichen Gespräch mehr über Ihre berufliche Haltung und Ihren Alltag als Pflegekraft zu erfahren.`,
  },
] as const;

const digitalTypeTemplates: readonly InterviewReminderChatMessageTemplate[] = [
  {
    informal: `Hallo {{{candidateFirstName}}},
wir freuen uns sehr auf das digitale Interview mit dir am {{{interviewDate}}} um {{{interviewTime}}}. Schön, dass wir uns bald virtuell kennenlernen können.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
wir freuen uns auf das digitale Vorstellungsgespräch am {{{interviewDate}}} um {{{interviewTime}}} und auf einen angenehmen, konstruktiven Austausch mit Ihnen.`,
  },
  {
    informal: `Hi {{{candidateFirstName}}},
super, dass wir uns bald sprechen! Dein digitales Interview findet am {{{interviewDate}}} um {{{interviewTime}}} statt – wir freuen uns schon auf das Gespräch mit dir.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
vielen Dank für Ihre Zeit. Wir sehen dem digitalen Interview am {{{interviewDate}}} um {{{interviewTime}}} mit großem Interesse entgegen.`,
  },
  {
    informal: `Hallo {{{candidateFirstName}}},
vielen Dank für deine Zeit. Wir freuen uns auf unser digitales Interview am {{{interviewDate}}} um {{{interviewTime}}} und darauf, dich besser kennenzulernen.`,
    formal: `Sehr geehrte/r {{{candidateLastNameWithSalutation}}},
hiermit bestätigen wir unser digitales Gespräch am {{{interviewDate}}} um {{{interviewTime}}}. Wir freuen uns auf einen wertschätzenden und informativen Austausch mit Ihnen.`,
  },
] as const;

export const interviewReminderChatTemplates: TemplateByMatchInterviewType = {
  [MatchInterviewType.Interview]: interviewTypeTemplates,
  [MatchInterviewType.TrialDay]: trialDayTypeTemplates,
  [MatchInterviewType.Telephonic]: telephonicTypeTemplates,
  [MatchInterviewType.Digital]: digitalTypeTemplates,
};

export const multipleInterviewReminderChatTemplates: readonly InterviewReminderChatMessageTemplate[] = [
  {
    informal: `Liebe(r) {{{candidateFirstName}}},
kleine Erinnerung für morgen, den {{{interviewDate}}}: Deine Interviews finden{{{location}}} statt und starten um {{{interviewTime}}}. Bitte leg dir alle wichtigen Unterlagen bereit. Viel Erfolg dir!`,
    formal: `Sehr geehrte(r) {{{candidateLastNameWithSalutation}}},
dies ist eine freundliche Erinnerung an Ihre Interviews morgen, am {{{interviewDate}}},{{{location}}}, beginnend um {{{interviewTime}}}. Bitte halten Sie alle benötigten Unterlagen griffbereit. Wir wünschen Ihnen viel Erfolg.`,
  },
  {
    informal: `Hey {{{candidateFirstName}}},
hier eine warme Erinnerung für morgen, den {{{interviewDate}}}: Deine Interviews beginnen{{{location}}} um {{{interviewTime}}}. Bitte halt alle nötigen Dokumente bereit. Wir wünschen dir alles Gute für die Gespräche!`,
    formal: `Liebe(r) {{{candidateLastNameWithSalutation}}},
wir möchten Sie herzlich daran erinnern, dass Ihre Interviews morgen, am {{{interviewDate}}},{{{location}}} um {{{interviewTime}}} starten. Bitte prüfen Sie alles Wichtige und halten Sie die benötigten Dokumente bereit. Wir wünschen Ihnen alles Gute für die Gespräche.`,
  },
] as const;
